import { Component, ContentChild, TemplateRef } from '@angular/core';
import { ModalBodyTemplateDirective } from 'app/shared/modal/modal-body-template.directive';
import { ModalService } from 'app/shared/modal/modal.service';

@Component({
  selector: 'app-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss']
})
export class ModalWrapperComponent {
  @ContentChild(ModalBodyTemplateDirective)
  modalBody: TemplateRef<ModalBodyTemplateDirective>;
  constructor(
    public modalService: ModalService
  ) {}
}
